import React from "react";
import logger from "logger";
import AccountDetailsSection from "TaskHistory/Tasklet/SubTasklets/AccountDetailsSection.js";
import StatusSection from "TaskHistory/Tasklet/SubTasklets/StatusSection.js";
import ErrorLogsSection from "TaskHistory/Tasklet/SubTasklets/ErrorLogsSection.js";
import ActionsSection from "TaskHistory/Tasklet/SubTasklets/ActionsSection.js";
import TaskletCard from "./TaskletCard";
import { StringValue } from "./StringValue";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { task } = props;

  return (
    <TaskletCard title="Gear Sort">
      <CardContent>
        <AccountDetailsSection task={task} />
        <StringValue
          label={"Selected Gear"}
          value={task.taskstatusdetail.selectedgearname}
        />
        <StringValue
          label={"Selected Gear Chest"}
          value={task.taskstatusdetail.selectedgearchestname}
        />
        <StatusSection task={task} />
        <StringValue
          label={"Total/Remaining:"}
          value={`${task.taskstatusdetail.totalgearchestcount}/
          ${task.taskstatusdetail.remaininggearchestcount}`}
        />
        <ErrorLogsSection task={task} />
      </CardContent>
      <ActionsSection task={task} />
    </TaskletCard>
  );
}
